// extracted by mini-css-extract-plugin
module.exports = {"communityInfo":"style_communityInfo__QifER"};